// =============================================================================
// Feedback bar — "Did this …?" Yes / Not yet → "Thanks, noted."
// =============================================================================

function initFeedbackBars() {
	document.querySelectorAll(".aa-feedback").forEach((bar) => {
		const thanks = bar.querySelector(".aa-feedback__thanks");
		bar.querySelectorAll(".aa-feedback__btn").forEach((btn) => {
			btn.addEventListener("click", () => {
				if (thanks) {
					thanks.hidden = false;
				}
				btn.setAttribute("aria-pressed", "true");
			});
		});
	});
}

document.addEventListener("DOMContentLoaded", initFeedbackBars);
